export const getSiNoFilterComponent = () => {
  function SiNoFilter() {
  }

  SiNoFilter.prototype.init = function(params) {
      this.eGui = document.createElement('div');
      this.eGui.innerHTML = '<select style="width:100%" ><option value="">Todo</option><option value="true">Sí</option><option value="false">No</option></select>';
      this.currentValue = null;
      this.eFilterInput = this.eGui.querySelector('select');
      var that = this;

      function onInputBoxChanged() {
          if (that.eFilterInput.value === '') {
              params.parentFilterInstance(function(instance) {
                  instance.onFloatingFilterChanged(null, null);
              });
              return;
          }

          that.currentValue = that.eFilterInput.value;
          params.parentFilterInstance(function(instance) {
              instance.onFloatingFilterChanged('equals', that.currentValue);
          });
      }

      this.eFilterInput.addEventListener('change', onInputBoxChanged);
  };

  SiNoFilter.prototype.onParentModelChanged = function(parentModel) {
      if (!parentModel) {
          this.eFilterInput.value = '';
          this.currentValue = null;
      } else {
          this.eFilterInput.value = parentModel.filter + '';
          this.currentValue = parentModel.filter;
      }
  };

  SiNoFilter.prototype.getGui = function() {
      return this.eGui;
  };

  return SiNoFilter;
}


export const getEstadoFilterComponent = () => {
  function EstadoFilter() {
  }

  EstadoFilter.prototype.init = function(params) {
      this.eGui = document.createElement('div');
      this.eGui.innerHTML = '<select><option value="">Todo</option><option value=1>Sin Validar</option><option value=2>Área</option><option value=3>Fiscal</option><option value=4>Facturación</option></select>';
      this.currentValue = null;
      this.eFilterInput = this.eGui.querySelector('select');
      var that = this;

      function onInputBoxChanged() {
          if (that.eFilterInput.value === '') {
              params.parentFilterInstance(function(instance) {
                  instance.onFloatingFilterChanged(null, null);
              });
              return;
          }

          that.currentValue = that.eFilterInput.value;
          params.parentFilterInstance(function(instance) {
              instance.onFloatingFilterChanged('equals', that.currentValue);
          });
      }

      this.eFilterInput.addEventListener('change', onInputBoxChanged);
  };

  EstadoFilter.prototype.onParentModelChanged = function(parentModel) {
      if (!parentModel) {
          this.eFilterInput.value = '';
          this.currentValue = null;
      } else {
          this.eFilterInput.value = parentModel.filter + '';
          this.currentValue = parentModel.filter;
      }
  };

  EstadoFilter.prototype.getGui = function() {
      return this.eGui;
  };

  return EstadoFilter;
}

export const getMostrarOcultarFilterComponent = () => {
    function SiNoFilter() {
    }
  
    SiNoFilter.prototype.init = function(params) {
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '<select style="width:100%" ><option value="">Todo</option><option value="true">Ocultar</option><option value="false">Mostrar</option></select>';
        this.currentValue = null;
        this.eFilterInput = this.eGui.querySelector('select');
        var that = this;
  
        function onInputBoxChanged() {
            if (that.eFilterInput.value === '') {
                params.parentFilterInstance(function(instance) {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }
  
            that.currentValue = that.eFilterInput.value;
            params.parentFilterInstance(function(instance) {
                instance.onFloatingFilterChanged('equals', that.currentValue);
            });
        }
  
        this.eFilterInput.addEventListener('change', onInputBoxChanged);
    };
  
    SiNoFilter.prototype.onParentModelChanged = function(parentModel) {
        if (!parentModel) {
            this.eFilterInput.value = '';
            this.currentValue = null;
        } else {
            this.eFilterInput.value = parentModel.filter + '';
            this.currentValue = parentModel.filter;
        }
    };
  
    SiNoFilter.prototype.getGui = function() {
        return this.eGui;
    };
  
    return SiNoFilter;
  }

  export const getSubirBajarFilterComponent = () => {
    function SiNoFilter() {
    }
  
    SiNoFilter.prototype.init = function(params) {
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '<select style="width:100%" ><option value="">Todo</option><option value="true">Subido</option><option value="false">En Posición</option></select>';
        this.currentValue = null;
        this.eFilterInput = this.eGui.querySelector('select');
        var that = this;
  
        function onInputBoxChanged() {
            if (that.eFilterInput.value === '') {
                params.parentFilterInstance(function(instance) {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }
  
            that.currentValue = that.eFilterInput.value;
            params.parentFilterInstance(function(instance) {
                instance.onFloatingFilterChanged('equals', that.currentValue);
            });
        }
  
        this.eFilterInput.addEventListener('change', onInputBoxChanged);
    };
  
    SiNoFilter.prototype.onParentModelChanged = function(parentModel) {
        if (!parentModel) {
            this.eFilterInput.value = '';
            this.currentValue = null;
        } else {
            this.eFilterInput.value = parentModel.filter + '';
            this.currentValue = parentModel.filter;
        }
    };
  
    SiNoFilter.prototype.getGui = function() {
        return this.eGui;
    };
  
    return SiNoFilter;
  }

export const getOtroFormatoFilterComponent = () => {
    function SiNoFilter() {
    }

    SiNoFilter.prototype.init = function(params) {
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '<select style="width:100%" ><option value="">Todo</option><option value="true">Otro Formato</option><option value="false">Formato habitual</option></select>';
        this.currentValue = null;
        this.eFilterInput = this.eGui.querySelector('select');
        var that = this;

        function onInputBoxChanged() {
            if (that.eFilterInput.value === '') {
                params.parentFilterInstance(function(instance) {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }

            that.currentValue = that.eFilterInput.value;
            params.parentFilterInstance(function(instance) {
                instance.onFloatingFilterChanged('equals', that.currentValue);
            });
        }

        this.eFilterInput.addEventListener('change', onInputBoxChanged);
    };

    SiNoFilter.prototype.onParentModelChanged = function(parentModel) {
        if (!parentModel) {
            this.eFilterInput.value = '';
            this.currentValue = null;
        } else {
            this.eFilterInput.value = parentModel.filter + '';
            this.currentValue = parentModel.filter;
        }
    };

    SiNoFilter.prototype.getGui = function() {
        return this.eGui;
    };

    return SiNoFilter;
}

export const getTipoValorFilterComponent = () => {
    function TipoValorFilter() {
    }

    TipoValorFilter.prototype.init = function(params) {
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = '<select style="width:100%" ><option value="">Todos</option><option value="00">Nacional</option><option value="99">Internacional</option><option value="A@">Area</option><option value="@@">Total</option></select>';
        this.currentValue = null;
        this.eFilterInput = this.eGui.querySelector('select');
        var that = this;

        function onInputBoxChanged() {
            if (that.eFilterInput.value === '') {
                params.parentFilterInstance(function(instance) {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }

            that.currentValue = that.eFilterInput.value;
            params.parentFilterInstance(function(instance) {
                instance.onFloatingFilterChanged('equals', that.currentValue);
            });
        }

        this.eFilterInput.addEventListener('change', onInputBoxChanged);
    };

    TipoValorFilter.prototype.onParentModelChanged = function(parentModel) {
        if (!parentModel) {
            this.eFilterInput.value = '';
            this.currentValue = null;
        } else {
            this.eFilterInput.value = parentModel.filter + '';
            this.currentValue = parentModel.filter;
        }
    };

    TipoValorFilter.prototype.getGui = function() {
        return this.eGui;
    };

    return TipoValorFilter;
}